var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-col",
        { staticClass: "pa-0 ma-0" },
        [
          _c(
            "v-card",
            { attrs: { loading: _vm.loading } },
            [
              _c(
                "v-row",
                {
                  staticClass: "pa-2",
                  attrs: {
                    "no-gutters": "",
                    align: "center",
                    justify: "center"
                  }
                },
                [
                  _c("v-text-field", {
                    class: {
                      "ma-2 fill-width": _vm.$vuetify.breakpoint.smAndDown,
                      "ma-2": !_vm.$vuetify.breakpoint.smAndDown
                    },
                    attrs: {
                      "append-icon": "mdi-magnify",
                      placeholder: "Buscar por nombre"
                    },
                    model: {
                      value: _vm.searchFilter,
                      callback: function($$v) {
                        _vm.searchFilter = $$v
                      },
                      expression: "searchFilter"
                    }
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "overline mx-2",
                      attrs: {
                        outlined: !_vm.ctdc,
                        dark: "",
                        color: "#0154a6"
                      },
                      on: {
                        click: function($event) {
                          return _vm.changeDatacenter(true)
                        }
                      }
                    },
                    [_vm._v("CTDC")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "overline mx-2",
                      attrs: { outlined: _vm.ctdc, dark: "", color: "#2B953E" },
                      on: {
                        click: function($event) {
                          return _vm.changeDatacenter(false)
                        }
                      }
                    },
                    [_vm._v("CTDV")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-fade-transition",
            [
              _c(
                "v-row",
                { staticClass: "my-4" },
                _vm._l(_vm.filteredData, function(i, k) {
                  return _c(
                    "v-col",
                    { key: k, attrs: { cols: "12", md: "6" } },
                    [
                      _c("ResumeListComponent", {
                        attrs: {
                          number: "#" + i.id,
                          type: _vm.type,
                          date: i.date,
                          name: i.name
                        },
                        on: { openFile: _vm.openFile }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", color: "error" },
          model: {
            value: _vm.snackbarError,
            callback: function($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError"
          }
        },
        [
          _vm._v(
            " Ocurrió un error obteniendo el archivo, por favor intente de nuevo "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.snackbarError = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }